"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typographyMixinValues = void 0;
exports.typographyMixinValues = {
    "bg-lg": {
        "fontFamily": "bg-large-font-family",
        "fontSize": "bg-large-font-size",
        "fontWeight": "bg-large-font-weight",
        "lineHeight": "bg-large-line-height"
    },
    "bg-md": {
        "fontFamily": "bg-medium-font-family",
        "fontSize": "bg-medium-font-size",
        "fontWeight": "bg-medium-font-weight",
        "lineHeight": "bg-medium-line-height"
    },
    "bg-sm": {
        "fontFamily": "bg-small-font-family",
        "fontSize": "bg-small-font-size",
        "fontWeight": "bg-small-font-weight",
        "lineHeight": "bg-small-line-height"
    },
    "title-xxl": {
        "fontFamily": "title-xxlarge-font-family",
        "fontSize": "title-xxlarge-font-size",
        "fontWeight": "title-xxlarge-font-weight",
        "lineHeight": "title-xxlarge-line-height"
    },
    "title-xl": {
        "fontFamily": "title-xlarge-font-family",
        "fontSize": "title-xlarge-font-size",
        "fontWeight": "title-xlarge-font-weight",
        "lineHeight": "title-xlarge-line-height"
    },
    "title-xl-secondary": {
        "fontFamily": "title-xlarge-secondary-font-family",
        "fontSize": "title-xlarge-secondary-font-size",
        "fontWeight": "title-xlarge-secondary-font-weight",
        "lineHeight": "title-xlarge-secondary-line-height"
    },
    "title-lg": {
        "fontFamily": "title-large-font-family",
        "fontSize": "title-large-font-size",
        "fontWeight": "title-large-font-weight",
        "lineHeight": "title-large-line-height"
    },
    "title-lg-secondary": {
        "fontFamily": "title-large-secondary-font-family",
        "fontSize": "title-large-secondary-font-size",
        "fontWeight": "title-large-secondary-font-weight",
        "lineHeight": "title-large-secondary-line-height"
    },
    "title-md": {
        "fontFamily": "title-medium-font-family",
        "fontSize": "title-medium-font-size",
        "fontWeight": "title-medium-font-weight",
        "lineHeight": "title-medium-line-height"
    },
    "title-md-secondary": {
        "fontFamily": "title-medium-secondary-font-family",
        "fontSize": "title-medium-secondary-font-size",
        "fontWeight": "title-medium-secondary-font-weight",
        "lineHeight": "title-medium-secondary-line-height"
    },
    "title-sm": {
        "fontFamily": "title-small-font-family",
        "fontSize": "title-small-font-size",
        "fontWeight": "title-small-font-weight",
        "lineHeight": "title-small-line-height"
    },
    "label-lg": {
        "fontFamily": "label-large-font-family",
        "fontSize": "label-large-font-size",
        "fontWeight": "label-large-font-weight",
        "lineHeight": "label-large-line-height"
    },
    "label-md": {
        "fontFamily": "label-medium-font-family",
        "fontSize": "label-medium-font-size",
        "fontWeight": "label-medium-font-weight",
        "lineHeight": "label-medium-line-height"
    },
    "label-sm": {
        "fontFamily": "label-small-font-family",
        "fontSize": "label-small-font-size",
        "fontWeight": "label-small-font-weight",
        "lineHeight": "label-small-line-height"
    },
    "label-sm-secondary": {
        "fontFamily": "label-small-secondary-font-family",
        "fontSize": "label-small-secondary-font-size",
        "fontWeight": "label-small-secondary-font-weight",
        "lineHeight": "label-small-secondary-line-height"
    },
    "label-xs": {
        "fontFamily": "label-xsmall-font-family",
        "fontSize": "label-xsmall-font-size",
        "fontWeight": "label-xsmall-font-weight",
        "lineHeight": "label-xsmall-line-height"
    },
    "paragraph-md": {
        "fontFamily": "paragraph-medium-font-family",
        "fontSize": "paragraph-medium-font-size",
        "fontWeight": "paragraph-medium-font-weight",
        "lineHeight": "paragraph-medium-line-height"
    },
    "paragraph-sm": {
        "fontFamily": "paragraph-small-font-family",
        "fontSize": "paragraph-small-font-size",
        "fontWeight": "paragraph-small-font-weight",
        "lineHeight": "paragraph-small-line-height"
    },
    "paragraph-xs": {
        "fontFamily": "paragraph-xsmall-font-family",
        "fontSize": "paragraph-xsmall-font-size",
        "fontWeight": "paragraph-xsmall-font-weight",
        "lineHeight": "paragraph-xsmall-line-height"
    },
    "paragraph-xs-secondary": {
        "fontFamily": "paragraph-xsmall-secondary-font-family",
        "fontSize": "paragraph-xsmall-secondary-font-size",
        "fontWeight": "paragraph-xsmall-secondary-font-weight",
        "lineHeight": "paragraph-xsmall-secondary-line-height"
    },
    "ribbon": {
        "fontFamily": "ribbon-base-font-family",
        "fontSize": "ribbon-base-font-size",
        "fontWeight": "ribbon-base-font-weight",
        "lineHeight": "ribbon-base-line-height"
    },
    "mini": {
        "fontFamily": "mini-base-font-family",
        "fontSize": "mini-base-font-size",
        "fontWeight": "mini-base-font-weight",
        "lineHeight": "mini-base-line-height"
    }
};
